"use client";
import { createContext, useContext } from "react";
const defaultTableContext = {
    placeholder: false,
    setPlaceholder: ()=>{},
    maxColumns: 0,
    setMaxColumns: ()=>{}
};
const TableContext = /*#__PURE__*/ createContext(defaultTableContext);
const useTableContext = ()=>useContext(TableContext);
export { TableContext, defaultTableContext, useTableContext };
